




<template>





  <v-card>


        <v-toolbar
      height="42"
      color="#4A76A8"
      dark flat

    >
    <v-card-title     >
            <span style="font-size:1.4em">   Создание нового задания  </span>
    </v-card-title>
    <v-spacer></v-spacer>

    <v-icon  @click="close()"> mdi-close</v-icon>
    </v-toolbar>





    <v-dialog  scrollable width="450"  persistent    v-model="newTask.actions.addLikeVideo.conditions.modal">
    <app-taskCond :conditions="newTask.actions.addLikeVideo.conditions" ></app-taskCond>
    </v-dialog>

    <v-dialog scrollable  width="450"  persistent    v-model="newTask.actions.commentVideo.conditions.modal">
    <app-taskCond :conditions="newTask.actions.commentVideo.conditions" ></app-taskCond>
    </v-dialog>

    <v-dialog scrollable  width="450"  persistent    v-model="newTask.actions.topicComment.conditions.modal">
    <app-taskCond :conditions="newTask.actions.topicComment.conditions" ></app-taskCond>
    </v-dialog>


    <v-dialog scrollable width="450"  persistent    v-model="newTask.actions.commentPost.conditions.modal">
    <app-taskCond :conditions="newTask.actions.commentPost.conditions" ></app-taskCond>
    </v-dialog>

    <v-dialog scrollable  width="450"  persistent    v-model="newTask.actions.likePost.conditions.modal">
    <app-taskCond :conditions="newTask.actions.likePost.conditions" ></app-taskCond>
    </v-dialog>


    <v-snackbar
      v-model="sb.snackbar"
      :color="sb.color"
      center top
       absolute

      :timeout="2000"

    >
      {{ sb.text  }}
      <v-btn
        dark
        flat
        @click="sb.snackbar = false"
      >
        ОК
      </v-btn>
    </v-snackbar>

<v-card-text>


  <v-text-field color="#4A76A8"  v-model="newTask.name" label="Название нового задания"></v-text-field>

<v-subheader>  <v-icon  color="orange">mdi-account-switch</v-icon>   <h3 style="color:orange;margin-left:5px">Параметры аккаунтов</h3></v-subheader>

<v-select
 @change="changeSelectedGr()"
 v-model = 'newTask.accGroupId'
 :items="newTask.accGroupsList"
 item-text = 'gr_title'
 item-value = 'gr_id'
 label="Выберите группу аккаунтов"
>

</v-select>





  <v-autocomplete
               v-model="newTask.accounts"
               no-data-text = "Нет аккаунтов для выбора "
               :items="newTask.accountsAll"
               hide-selected
               chips
               color="#4A76A8"
               label="Выберите как минимум один или несколько аккаунтов"
               item-text="title"
               item-value="id"
               multiple
             >
             <template
              slot="selection"
              slot-scope="data"
            >
              <v-chip

                :selected="data.selected"
                close
                class="chip--select-multi"
                @input="removeSelectedAccount(data.item)"
              >
                <v-avatar>
                  <img :src="data.item.photo_50">
                </v-avatar>
                {{ data.item.title }}
              </v-chip>
            </template>

            <template
              slot="item"
              slot-scope="data"
            >
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.title"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-avatar>
                  <img :src="data.item.photo_50">
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.title"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>



             </v-autocomplete>

             <v-select
               color="#4A76A8"
               v-model="newTask.accountSettings.mode"
               :items="newTask.accountSettings.options"

             ></v-select>



 <div  @click="newTask.replaceThenBlock = false"><v-checkbox  v-model="newTask.stopBlock" label="Остановить задание если один из аккаунтов заблокирован ?"></v-checkbox></div>
 <v-checkbox v-if="!newTask.stopBlock" v-model="newTask.replaceThenBlock" label="Заменить любым другим если один из аккаунтов заблокирован ?"></v-checkbox>
 <div  @click="newTask.replaceThenLimit = false"><v-checkbox v-model="newTask.stopLimit" label="Остановить задание если  на одном из аккаунтов лимит на действия ?"></v-checkbox></div>
 <v-checkbox v-if="!newTask.stopLimit" v-model="newTask.replaceThenLimit" label="Заменить любым другим если  на одном из аккаунтов лимит на действия ?"> </v-checkbox>









<v-subheader> <v-icon  color="orange">mdi-worker</v-icon>  <h3 style="color:orange;margin-left:5px">Параметры действий</h3></v-subheader>


  <v-autocomplete
               v-model="newTask.selectedContentType"
               no-data-text = "Нет такого типа контента"
               :items="newTask.contentType"
               hide-selected
               color="#4A76A8"
               label="Выберите тип контента"
               item-text="text"
               item-value="value"

             >
             <template
              slot="selection"
              slot-scope="data"
            >

                <v-avatar>
                  <v-icon medium :color="data.item.color">mdi-{{data.item.icon}}</v-icon>
                </v-avatar>
                <span style="color:#4A76A8;font-weight:bold">{{ data.item.text}} </span>

            </template>

            <template
              slot="item"
              slot-scope="data"
            >
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.title"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-avatar>
                    <v-icon :color="data.item.color">mdi-{{data.item.icon}}</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>



             </v-autocomplete>













<div v-if="newTask.selectedContentType">

<div v-if="newTask.selectedContentType == 'topics'">
  <v-expansion-panel focusable inset>

    <v-expansion-panel-content>
      <div  class="text-xs-center"  slot="header"><span style="font-weight:bold;color:#707070;font-size:1.3em;">Прокомментировать </span> <span  v-if="newTask.actions.topicComment.activated" style="margin-left:10px;font-weight:bold;color:green;font-size:1.3em">(актив.) </span> </div>
      <v-card>
        <div style="padding:5px">
<div style="margin:10px">  <v-textarea clearable v-model="newTask.actions.topicComment.text" color="#4A76A8" label="Введите ваш комментарий"></v-textarea> </div>
<div  @click="conditionAct('topicComment')"><v-checkbox color="#4A76A8" v-model="newTask.actions.topicComment.conditions.activated" label="Добавить условия выполнения"> </v-checkbox></div>
<v-checkbox color="#4A76A8" v-model="newTask.actions.topicComment.activated" label="Активировать действие"> </v-checkbox>
        </div>
      </v-card>
    </v-expansion-panel-content>

  </v-expansion-panel>
</div>


<div v-else-if="newTask.selectedContentType == 'posts'">
  <v-expansion-panel focusable inset>

    <v-expansion-panel-content>
      <div  class="text-xs-center"  slot="header"><span style="font-weight:bold;color:#707070;font-size:1.3em;">Прокомментировать </span> <span  v-if="newTask.actions.commentPost.activated" style="margin-left:10px;font-weight:bold;color:green;font-size:1.3em">(актив.) </span> </div>
      <v-card>
        <div style="padding:5px">
<div style="margin:10px">  <v-textarea clearable v-model="newTask.actions.commentPost.text" color="#4A76A8" label="Введите ваш комментарий"></v-textarea> </div>
<div  @click="conditionAct('commentPost')"><v-checkbox color="#4A76A8" v-model="newTask.actions.commentPost.conditions.activated" label="Добавить условия выполнения"> </v-checkbox></div>
<v-checkbox color="#4A76A8" v-model="newTask.actions.commentPost.activated" label="Активировать действие"> </v-checkbox>
        </div>
      </v-card>
    </v-expansion-panel-content>

    <v-expansion-panel-content focusable inset>
      <div  class="text-xs-center"  slot="header"><span style="font-weight:bold;color:#707070;font-size:1.3em;">Поставить лайк </span> <span  v-if="newTask.actions.likePost.activated" style="margin-left:10px;font-weight:bold;color:green;font-size:1.3em">(актив.) </span> </div>
      <v-card>
        <div style="padding:5px">
<div  @click="conditionAct('likePost')"><v-checkbox color="#4A76A8" v-model="newTask.actions.likePost.conditions.activated" label="Добавить условия выполнения"> </v-checkbox></div>
<v-checkbox color="#4A76A8" v-model="newTask.actions.likePost.activated" label="Активировать действие"> </v-checkbox>
        </div>
      </v-card>
    </v-expansion-panel-content>



  </v-expansion-panel>
</div>





<div v-else>
  <v-expansion-panel focusable inset>


    <v-expansion-panel-content>
      <div  class="text-xs-center"  slot="header"><span style="font-weight:bold;color:#707070;font-size:1.3em;">Скачать </span> <span  v-if="newTask.actions.commentVideo.activated" style="margin-left:10px;font-weight:bold;color:green;font-size:1.3em">(актив.) </span> </div>
      <v-card>
        <div style="padding:5px">
<div style="margin:10px">  <v-textarea clearable v-model="newTask.actions.commentVideo.text" color="#4A76A8" label="Введите ваш комментарий"></v-textarea> </div>
<div  @click="conditionAct('commentVideo')"><v-checkbox color="#4A76A8" v-model="newTask.actions.commentVideo.conditions.activated" label="Добавить условия выполнения"> </v-checkbox></div>
<v-checkbox color="#4A76A8" v-model="newTask.actions.commentVideo.activated" label="Активировать действие"> </v-checkbox>
        </div>
      </v-card>
    </v-expansion-panel-content>



    <v-expansion-panel-content>
      <div  class="text-xs-center"  slot="header"><span style="font-weight:bold;color:#707070;font-size:1.3em;">Прокомментировать </span> <span  v-if="newTask.actions.commentVideo.activated" style="margin-left:10px;font-weight:bold;color:green;font-size:1.3em">(актив.) </span> </div>
      <v-card>
        <div style="padding:5px">
<div style="margin:10px">  <v-textarea clearable v-model="newTask.actions.commentVideo.text" color="#4A76A8" label="Введите ваш комментарий"></v-textarea> </div>
<div  @click="conditionAct('commentVideo')"><v-checkbox color="#4A76A8" v-model="newTask.actions.commentVideo.conditions.activated" label="Добавить условия выполнения"> </v-checkbox></div>
<v-checkbox color="#4A76A8" v-model="newTask.actions.commentVideo.activated" label="Активировать действие"> </v-checkbox>
        </div>
      </v-card>
    </v-expansion-panel-content>

    <v-expansion-panel-content>
      <div  class="text-xs-center"  slot="header"><span style="font-weight:bold;color:#707070;font-size:1.3em;">Поставить лайк </span> <span  v-if="newTask.actions.addLikeVideo.activated" style="margin-left:10px;font-weight:bold;color:green;font-size:1.3em">(актив.) </span> </div>
      <v-card>
        <div style="padding:5px">
<div  @click="conditionAct('addLikeVideo')"><v-checkbox color="#4A76A8" v-model="newTask.actions.addLikeVideo.conditions.activated" label="Добавить условия выполнения"> </v-checkbox></div>
<v-checkbox color="#4A76A8" v-model="newTask.actions.addLikeVideo.activated" label="Активировать действие"> </v-checkbox>
        </div>
      </v-card>
    </v-expansion-panel-content>



    <v-expansion-panel-content>
      <div  class="text-xs-center"  slot="header"><span style="font-weight:bold;color:#707070;font-size:1.3em;">Загрузить </span> <span  v-if="newTask.actions.commentVideo.activated" style="margin-left:10px;font-weight:bold;color:green;font-size:1.3em">(актив.) </span> </div>
      <v-card>
        <div style="padding:5px">
<div style="margin:10px">  <v-textarea clearable v-model="newTask.actions.commentVideo.text" color="#4A76A8" label="Введите ваш комментарий"></v-textarea> </div>
<div  @click="conditionAct('commentVideo')"><v-checkbox color="#4A76A8" v-model="newTask.actions.commentVideo.conditions.activated" label="Добавить условия выполнения"> </v-checkbox></div>
<v-checkbox color="#4A76A8" v-model="newTask.actions.commentVideo.activated" label="Активировать действие"> </v-checkbox>
        </div>
      </v-card>
    </v-expansion-panel-content>

  </v-expansion-panel>
</div>

<v-checkbox v-model="newTask.allActionsImportant" label="Обязательно выполнять все выбранные действия"></v-checkbox>

</div>




<v-subheader>    <v-icon  color="orange">mdi-tune</v-icon>  <h3 style="color:orange;margin-left:5px">Параметры задания</h3></v-subheader>
  <v-subheader>Минимальная и Максимальная задержка между действиями (сек.)</v-subheader>
  <v-card-text>

    <v-layout row>

      <v-flex class="px-3">
        <v-range-slider
        color="#4A76A8"
        thumb-label="always"
          v-model="newTask.actionsTimeout.range"
          :max="newTask.actionsTimeout.max"
          :min="newTask.actionsTimeout.min"
        ></v-range-slider>
      </v-flex>

    </v-layout>
  </v-card-text>


  <v-subheader>Минимальная и Максимальная задержка между ресурсами (сек.)</v-subheader>
  <v-card-text>

    <v-layout row>

      <v-flex class="px-3">
        <v-range-slider
        color="#4A76A8"
        thumb-label="always"
          v-model="newTask.resourcesTimeout.range"
          :max="newTask.resourcesTimeout.max"
          :min="newTask.resourcesTimeout.min"
        ></v-range-slider>
      </v-flex>

    </v-layout>
  </v-card-text>





<v-subheader> <v-icon  color="orange">mdi-database-plus</v-icon>  <h3 style="color:orange;margin-left:5px">Параметры ресурсов</h3></v-subheader>
<v-textarea
color="#4A76A8"
clearable v-model="newTask.resources"
label="список ресурсов, над которыми будет выполнено задание (необязательно)"
>

</v-textarea>
<app-procBinding :init="selectedProc"> </app-procBinding>

<v-checkbox v-model="newTask.exceptDuble" label="Исключать повторение ресурсов ?"></v-checkbox>

<v-btn color="#4A76A8" :loading="ui.createLoading"  flat @click="createNewTask()" block>
  Создать задание
</v-btn>


</v-card-text>


  </v-card>


</template>

<script>

import axios from 'axios'
export default {
 components:{},
 props: ['modals','tasks'],
  data () {
    return {
    procesess: {
      procResults: {
        items: [],
        selected: [],
        active: false,
      },
      procResultsLabel: "Привязать результаты процессов",
      procUpdates: {
        items: [],
        selected: [],
        active: true,
      },
      procUpdatesLabel: "Привязать результаты обновлений процессов",
      contentType: 'videos',
    },


      ui:{
        createLoading: false
      },
      active: null,
      sb:{
      snackbar: false,
      color: 'success',
      text: ''
    },


  newTask:{

    selectedContentType : "topics",

    contentType: [
      {
        text: "видео",
        value: "videos",
        icon: "youtube",
        color: "red",

      },
      {
        text: "обсуждения",
        value: "topics",
        icon: "message-reply-text",
        color: "yellow",

      },
      {
        text: "Посты",
        value: "posts",
        icon: "comment-multiple-outline",
        color: "pink",
      },
    ],
    name: '',
    accGroupId: '1',
    accGroupsList: [],
    accounts: [],
    accountsAll:[  ],
    actions:{
      downloadVideo:   {
          type: 'downloadVideo',
          activated: false,
          text: "",
          conditions:{
            modal: false,
            activated: false,
            type: "content",
            cond: {
      viewMin: "",
      viewMax:"",
      likesMax:"",
      likesMin:"",
      commentsMax:"",
      commentsMin:"",
            },
          }
        },
    addLikeVideo:   {
        type: 'addLikeVideo',
        activated: false,
        text: "",
        conditions:{
          modal: false,
          activated: false,
          type: "content",
          cond: {
    viewMin: "",
    viewMax:"",
    likesMax:"",
    likesMin:"",
    commentsMax:"",
    commentsMin:"",
          },
        }
      },
      commentVideo:   {
          type: 'commentVideo',
          activated: false,
          text:"",

          conditions:{
            modal: false,
            activated: false,
            type: "content",
            cond: {
              viewMin: "",
              viewMax:"",
              likesMax:"",
              likesMin:"",
              commentsMax:"",
              commentsMin:"",
            },
          },
        },
        uploadVideo:   {
            type: 'uploadVideo',
            activated: false,
            text: "",
            conditions:{
              modal: false,
              activated: false,
              type: "content",
              cond: {
        viewMin: "",
        viewMax:"",
        likesMax:"",
        likesMin:"",
        commentsMax:"",
        commentsMin:"",
              },
            }
          },



    topicComment:   {
            type: 'topicComment',
            activated: false,
            conditions:{
              modal: false,
              activated: false,
              type: "content",
              cond: {
                commentsMax:"",
                commentsMin:"",
              },
            }
          },
          commentPost:   {
                  type: 'commentPost',
                  activated: false,
                  conditions:{
                    modal: false,
                    activated: false,
                    type: "content",
                    cond: {
                      commentsMax:"",
                      commentsMin:"",
                    },
                  }
                },
                likePost:   {
                        type: 'likePost',
                        activated: false,
                        conditions:{
                          modal: false,
                          activated: false,
                          type: "content",
                          cond: {
                            commentsMax:"",
                            commentsMin:"",
                          },
                        }
                      },
    },
    resources:"",
    resourcesTimeout:{
      min: 2,
      max: 90,
      range: [1, 8]
    },
    actionsTimeout:{
      min: 5,
      max: 90,
      range: [5, 15]
    },
    accountSettings:{
      mode: 1,
      options: [{value:1, text:"Выполнять задание рандомно с одного аккаунта"},{value:2, text:"Выполнять задание с каждого  аккаунта по порядку"}],
    },
    stopLimit: null,
    stopBlock: null,
    replaceThenLimit: null,
    replaceThenBlock: null,
    allActionsImportant: true,
    exceptDuble: true,
    useSourceInfo: false,

  }
    }
  },
  methods: {
    changeSelectedGr(){
      axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_get.php', {
           method: 'get',
           params: {grId:this.newTask.accGroupId},
         }).then(response => {
       this.newTask.accountsAll = response.data.filter((item, i , arr)=>{

       if(item.info.valid == "1"  && item.info.task_able == "1"){
         return true
       } else return false
     })
         })
    },
    removeSelectedAccount (item) {

    const index = this.newTask.accounts.indexOf(item.id)
    if (index >= 0) this.newTask.accounts.splice(index, 1)
  },

  conditionAct(actName){

    if(actName == 'likePost'){

      if( this.newTask.actions.likePost.conditions.activated ){
        this.newTask.actions.likePost.conditions.activated = true
        this.newTask.actions.likePost.conditions.modal = true
      } else  {
        this.newTask.actions.likePost.conditions.modal =  false

      }
    }

    if(actName == 'commentPost'){

      if(this.newTask.actions.commentPost.conditions.activated){
        this.newTask.actions.commentPost.conditions.activated = true
        this.newTask.actions.commentPost.conditions.modal = true
      } else  {
        this.newTask.actions.commentPost.conditions.modal =  false
      }
    }








    if(actName == 'addLikeVideo'){

      if( this.newTask.actions.addLikeVideo.conditions.activated ){
        this.newTask.actions.addLikeVideo.conditions.activated = true
        this.newTask.actions.addLikeVideo.conditions.modal = true
      } else  {
        this.newTask.actions.addLikeVideo.conditions.modal =  false

      }
    }

    if(actName == 'topicComment'){

      if(this.newTask.actions.topicComment.conditions.activated){
        this.newTask.actions.topicComment.conditions.activated = true
        this.newTask.actions.topicComment.conditions.modal = true
      } else  {
        this.newTask.actions.topicComment.conditions.modal =  false
      }
    }

    if(actName == 'commentVideo'){

      if(this.newTask.actions.commentVideo.conditions.activated){

        this.newTask.actions.commentVideo.conditions.activated = true
        this.newTask.actions.commentVideo.conditions.modal = true
      } else  {
        this.newTask.actions.commentVideo.conditions.modal =  false
      }
    }
  },

   messageAct(){

     if( this.newTask.actions.messageSend.activated ){
       this.newTask.actions.messageSend.activated = true
       this.newTask.modals.message = true
     } else  {
       this.newTask.actions.messageSend.activated =  false
     }
   },


    close( ){
       this.modals.creator = false
    },
    createNewTask(){

    let params = {}

      params.params = {}
      params.dynamic = {}
      params.contentType = this.newTask.selectedContentType
      params.name = this.newTask.name
      params.accounts = this.newTask.accounts
      params.actions = this.newTask.actions
      params.grId = this.newTask.accGroupId


      params.resources = this.newTask.resources
      params.params.resourcesTimeout = this.newTask.resourcesTimeout
      params.params.actionsTimeout  = this.newTask.actionsTimeout
      params.params.stopBlock  = this.newTask.stopBlock
      params.params.stopLimit  = this.newTask.stopLimit
      params.params.replaceThenBlock  = this.newTask.replaceThenBlock
      params.params.replaceThenLimit  = this.newTask.replaceThenLimit
      params.params.exceptDuble  = this.newTask.exceptDuble
      params.params.allActionsImportant  = this.newTask.allActionsImportant
      params.params.accountsMode  = this.newTask.accountSettings.mode
      params.dynamic.procesess = this.procesess.procUpdates.selected

      if(params.accounts.length<1){
        this.sb.snackbar = true
        this.sb.color = "error"
        this.sb.text = "Выберите хотя бы один аккаунт"
      } else if (!params.actions.addLikeVideo.activated && !params.actions.commentVideo.activated && !params.actions.addLikeVideo.activated && !params.actions.likePost.activated && !params.actions.commentPost.activated && !params.actions.topicComment.activated  ) {
        this.sb.snackbar = true
        this.sb.color = "error"
        this.sb.text = "Активируйте хотя бы одно действие"
      }
else {

      this.ui.createLoading = true
      axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/taks_creator.php', {
           method: 'POST',
           data: {params:params}
         }).then(response => {
           console.log(response.data)
           this.ui.createLoading = false

     if(response.data == 1){

       axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/task_for_export.php', {
            method: 'POST',
            data: {
              contentType: 'content'
            }
          })
          .then( response => {
            response.data.forEach(
           (item,i,arr)=>{
             item.status = JSON.parse(item.status)
           }
         )
            this.tasks.tasksList = response.data
          })


       this.sb.snackbar = true
       this.sb.color = "success"
       this.sb.text = "Задание было успешно созданно "
       setTimeout(()=>{this.modals.creator = false}, 2000)
     } else {
       this.sb.snackbar = true
       this.sb.color = "error"
       this.sb.text = response.data.error
     }
         })

   }
    }



  },
  computed:{

    selectedProc(){
      this.procesess.contentType = this.newTask.selectedContentType
      return this.procesess
    },

  },
  mounted(){

        axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/gr_list_get.php', {
           contentType: 'JSONP',
           method: 'get',
           }).then(response => {
              this.newTask.accGroupsList = response.data
           })


        axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/resources/accounts/accounts_get.php', {
             method: 'get',
           }).then(response => {
       this.newTask.accountsAll = response.data.filter((item, i , arr)=>{

         if(item.info.valid == "1"  && item.info.task_able == "1"){
           return true
         } else return false
       })
           })



           axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/get_processes.php', {
                method: 'POST',
                data: {contentType:'pages'},
              }).then(response => {
           this.procesess.items = response.data
           console.log(this.procesess)
              })

  },

}
</script>

<style   >

</style>
